import { defineFcm } from '../shared/factory';

export const FCM_MEMBER_PHONE_COLLECTION = defineFcm('member_phone_collection')
	.asBoolean()
	.withDefault(false)
	.toConfig();
